import axios from "axios";

const instance = axios.create({
    baseURL: "./server/controller/"
});

// instance.defaults.headers.common['SOMETHING'] = 'SOMETHING'

export default instance;
